// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".button-back-to-parent-page{display:inline-flex;align-items:center;text-decoration:none}.button-back-to-parent-page_text{margin-left:16px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
